exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coins .coin{width:320px;height:260px;background:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/bank_coins_bg.png\") bottom no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bff2b6f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/coins.vue
// module id = 397
// module chunks = 0